export enum DtoDirection {
    TO_DTO,
    FROM_DTO
}